import { Box, Typography } from "@material-ui/core";
import { ElectricBolt } from "@mui/icons-material";
import { styled } from "@mui/material";
import React from "react";

import { imagesList } from "../../../constants";
import { primary } from "../../../constants/theme";

const CustomAboutTurno = styled(Box)(({ theme }) => ({
  height: "500px",
  padding: "16% 10% 14% 10%",
  background: `linear-gradient(179.94deg, rgba(0, 0, 0, 0.94) 0.05%, rgba(0, 0, 0, 0) 90.96%), url(${imagesList.aboutUsBanner})`,

  ".turno-electric": {
    fontSize: "28px",
    lineHeight: "42px",
    fontWeight: "400",
    color: primary.white,
    // textTransform:'capitalize',
    ".electric": {
      color: primary.main,
    },
  },
  ".heading-about-turno": {
    fontSize: "48px",
    lineHeight: "64px",
    fontWeight: "700",
    color: primary.white,
    // textTransform: "capitalize",
    span: {
      color: primary.electricGreen, //"#00EE98",
    },
  },
  [theme.breakpoints.down("md")]: {
    padding: "80% 16px 14% 16px",
    ".turno-electric": {
      fontSize: "18px",
      lineHeight: "27px",
      marginBottom: "12px",
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },
    ".heading-about-turno": {
      fontSize: "25px",
      lineHeight: "35px",
    },
  },
}));

const AboutTurno = () => {
  return (
    <CustomAboutTurno>
      <Box>
        <Typography variant="h1" className="turno-electric">
          Turno Electric <ElectricBolt className="electric" />
        </Typography>
        <Typography
          className="heading-about-turno"
          dangerouslySetInnerHTML={{
            __html: `${"Driving towards a <span>sustainable future</span>"}`,
          }}
        ></Typography>
      </Box>
    </CustomAboutTurno>
  );
};
export default AboutTurno;
